import {
  GET_POLICY_LIST,
  GET_POLICY_LIST_FAIL,
  GET_POLICY_LIST_SUCCESS,
  DELETE_POLICY,
  DELETE_POLICY_FAIL,
  DELETE_POLICY_SUCCESS,
  UPLOAD_POLICY_DOC,
  UPLOAD_POLICY_DOC_FAIL,
  UPLOAD_POLICY_DOC_SUCCESS,
} from "./actionTypes";

export const deletePolicy = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: DELETE_POLICY,
  payload: { data, onSuccess, onError },
});

export const deletePolicySuccess = data => ({
  type: DELETE_POLICY_SUCCESS,
  payload: data,
});

export const deletePolicyFail = data => ({
  type: DELETE_POLICY_FAIL,
  payload: data,
});

export const getPolicyList = (data = {}) => ({
  type: GET_POLICY_LIST,
  payload: data,
});

export const getPolicyListSuccess = data => ({
  type: GET_POLICY_LIST_SUCCESS,
  payload: data,
});

export const getPolicyListFail = data => ({
  type: GET_POLICY_LIST_FAIL,
  payload: data,
});

export const addPolicyDocument = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: UPLOAD_POLICY_DOC,
  payload: { data, onSuccess, onError },
});

export const addPolicyDocumentSuccess = data => ({
  type: UPLOAD_POLICY_DOC_SUCCESS,
  payload: data,
});

export const addPolicyDocumentFail = data => ({
  type: UPLOAD_POLICY_DOC_FAIL,
  payload: data,
});
